import { Badge, EmptyState, Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/components";

import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel.tsx";
import { Vestiging } from "@/entities/vestiging";
import { VestigingenUpdateHandler } from "../../shared";
import { BehandeldeAanvragenKlantenservice } from "../behandelde-aanvragen";
import { OpenAanvragenKlantenservice } from "../open-aanvragen";

type FaciliteitenDetailsKlantenserviceProps = {
    vestigingen: Vestiging[];
    onVestigingenUpdate: VestigingenUpdateHandler;
};

export function FaciliteitenDetailsKlantenservice({ vestigingen, onVestigingenUpdate }: Readonly<FaciliteitenDetailsKlantenserviceProps>) {
    const openAanvragen = vestigingen.filter(Vestiging.isKlantenserviceOpenAanvraag);
    const behandeldeAanvragen = vestigingen.filter(Vestiging.isKlantenserviceBehandeldeAanvraag);

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="Faciliteiten" showBackButton />
            <DossierDetailsContent className="space-y-6">
                <div className="space-y-6">
                    <Tabs defaultValue="open" className="w-full gap-6">
                        <TabsList>
                            <TabsTrigger value="open" className="relative">
                                Open aanvragen
                                {openAanvragen.length > 0 && (
                                    <Badge variant="default" className="h-4 min-w-[1.25rem]">
                                        {openAanvragen.length}
                                    </Badge>
                                )}
                            </TabsTrigger>
                            <TabsTrigger value="processed">Behandelde aanvragen</TabsTrigger>
                        </TabsList>
                        <TabsContent value="open">
                            <div className="space-y-6">
                                {openAanvragen.length === 0 ? (
                                    <EmptyState>Op dit moment zijn er geen openstaande aanvragen</EmptyState>
                                ) : (
                                    <OpenAanvragenKlantenservice vestigingen={openAanvragen} onVestigingenUpdate={onVestigingenUpdate} />
                                )}
                            </div>
                        </TabsContent>
                        <TabsContent value="processed">
                            <div className="space-y-6">
                                {behandeldeAanvragen.length === 0 ? (
                                    <EmptyState>Op dit moment zijn er geen behandelde aanvragen</EmptyState>
                                ) : (
                                    <BehandeldeAanvragenKlantenservice vestigingen={behandeldeAanvragen} />
                                )}
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
